export default "__VITE_ASSET__BdLGGxzp__"